import React, {Component} from 'react';
import { storage } from '../../../firebase/index';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import withErrorHandler from '../../../containers/hoc/withErrorHandler/withErrorHandler';

import axios from '../../../axios-drops';
import TrdAdminFocusItem from './TrdAdminFocusItem/TrdAdminFocusItem';
import Spinner from '../../UI/Spinner/Spinner';
import Aux from '../../../containers/hoc/Auxiliary';
import Button from '../../UI/Buttons/Button/Button';

import FlashModal from '../Modal/FlashModal/FlashModal';
import Modal from '../Modal/Modal';
import ModalSafetyMessage from '../Modal/ModalSafetyMessage/ModalSafetyMessage';
import TrdResults from './TrdResults/TrdResults';
import BackIconButton from '../Buttons/BackIconButton/BackIconButton';

import classes from './TrdAdminFocus.css';


class TrdAdminFocus extends Component {

    state = {
        drop: null,
        registrations: [],
        deleteClicked: false,
        endTrd: false,
        // disableButtonUse: false,
        alreadyPlayed: null,
        deleted: false
    }

    componentDidMount () {
        window.scrollTo(0, 0)

        let registrations = []
        let fetchedDrop = null

        if ( this.props.match.params.id ) {

            const func = async () => {
                await axios.get('/drops/'+ this.props.match.params.id + '.json')
                    .then(response => {
                        fetchedDrop = response.data
                    
                        this.setState({drop: fetchedDrop,
                                    alreadyPlayed: !response.data.current,
                                    endTrd: !response.data.current
                        })
                    })
    
                await axios.get('/registrations/' + this.props.match.params.id + '.json')
                    .then(response => {
                        for (let key in response.data.general) {
                            registrations.push({
                                ...response.data[key],
                                id: key
                            })
                        }
                        this.setState({registrations: registrations})
                    }).catch(err => {

                    })
            }
            func()
        }
    }

    returnButtonClickedHandler = () => {
     
        if (this.props.location.lastPage === 'console'){
            this.props.history.push('/admin')
        } else if (this.props.location.lastPage === 'archive'){
            this.props.history.push('/admin/archive/trd')
        } else {
            this.props.history.push('/admin')
        }
    }

    deleteClickedHandler = () => {
        this.disableScroll()
        this.setState({deleteClicked: true})
    }

  

    closeModalHandler = () => {
        this.enableScroll()
        this.setState({deleteClicked: false})
    }

    deleteYesClicked = async () => {

        this.enableScroll()

        this.setState({deleted: true})

        setTimeout(() => {
            this.setState({deleted: false})
               
        }, 1000)

        await axios.delete('/drops/' + this.props.match.params.id + '/.json')
        
        await axios.delete('/registrations/' + this.props.match.params.id + '/.json')
     
        await storage.ref().child('images/' + this.state.drop.imageName).delete()
          
        this.reRoute();

    }

    endGameHandler = () => {

        this.updateDropData();
    }

    updateDropData = async () => {
        
        const update = {
            name: this.state.drop.name,
            variant: this.state.drop.variant,
            image: this.state.drop.image,
            edition: this.state.drop.edition,
            originallyAvailable: this.state.drop.originallyAvailable,
            availability: this.state.drop.availability,
            cost: this.state.drop.cost,
            showInfo: this.state.drop.showInfo,
            current: true,
            dropClosed: true,
            type: this.state.drop.type,
            imageName: this.state.drop.imageName
        }

        await axios.patch('./drops/' + this.props.match.params.id + '/.json', update)
            .then(response => {
                this.setState({endTrd: true})
            })

    }

    reRoute = () => {
        this.returnButtonClickedHandler();
    }

    editClickedHandler = () => {
        if (this.props.location.lastPage === 'console'){
            this.props.history.push({
                pathname: '/admin/focus/trd/edit/' + this.props.match.params.id,
                lastPage: 'console'})
        } else if (this.props.location.lastPage === 'archive'){
            this.props.history.push({
                pathname: '/admin/focus/trd/edit/' + this.props.match.params.id,
                lastPage: 'archive'
            })
        }
    }


    disableScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

        window.onscroll = () => {
            window.scrollTo(scrollLeft, scrollTop)
        }
    }

    enableScroll = () => {
        window.onscroll = () => {}
    }


 

    render() {

        let focusPage = <div className={classes.Spinner}><Spinner/></div>
        let gameReady = false

        if (this.state.registrations.length > 0 && this.state.drop != null) {
            if (this.state.registrations.length >= this.state.drop.availability) {
                gameReady = true
            }
        }

        let functionalTrdComponent = 
        <div className={classes.TrdGameButton}>
            <Button btnType="Submit" 
                    disabled={!gameReady}
                    clicked={this.endGameHandler}>
                    End TRD 
            </Button>
            <p className={classes.Message}>(*) Button Active when Registrations > Availability</p>
        </div>

        if (this.state.endTrd) {
            functionalTrdComponent = 
                <TrdResults 
                    dropId={this.props.match.params.id}
                    dropInfo={this.state.drop} 
                    alreadyPlayed={this.state.alreadyPlayed}
                    bttnClicked={this.state.endTrd}
                    /> 
        }

        
        let modalMessage = <div><h2>404: Error Not Found</h2></div>

        if (this.state.deleteClicked) {
            modalMessage = <ModalSafetyMessage 
                message={"Are you sure you want to Delete?"} 
                btnType={"Delete"} 
                yesClicked={this.deleteYesClicked}
                noClicked={this.closeModalHandler}/>
        } 

         if (this.state.drop !== null) {
            focusPage = 
            <div className={classes.TrdAdminFocus}>
                <TrdAdminFocusItem 
                image={this.state.drop.image}
                name={this.state.drop.name}
                variant={this.state.drop.variant}
                edition={this.state.drop.edition}
                cost={this.state.drop.cost}
                numberAvail={this.state.drop.availability}
                orginallyAvailable={this.state.drop.originallyAvailable}
                registrations={this.state.registrations.length}
                id={this.props.match.params.id}
                deleteClicked={this.deleteClickedHandler}
                editClicked={this.editClickedHandler}/>
                <hr></hr>
                <div className={classes.BottomLevel}>
                    {functionalTrdComponent}
                </div>
                <Modal show={this.state.deleteClicked} modalClosed={this.closeModalHandler}>
                    {modalMessage}
                </Modal>
                <FlashModal show={this.state.deleted} >
                    Deleted
                </FlashModal>
            </div>
         }

         
        let redirect = null

        if (!this.props.isAuth) {
            redirect = <Redirect to="/signin" />
        }
         
       
        return (
            <Aux>
                {redirect}
                {focusPage}
                <BackIconButton clicked={this.returnButtonClickedHandler} />
            </Aux>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        isAuth: state.token !== null
    }
}

export default connect(mapStateToProps)(withErrorHandler(TrdAdminFocus, axios))


// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdAdminFocus.js